import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';
import ContextProvider from 'common/contexts/crud';

const ServiceContext = createContext();

export const ServicesProvider = ({ children }) => (
  <ContextProvider url="services" context={ServiceContext}>{children}</ContextProvider>
);

ServicesProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

const useService = () => useContext(ServiceContext);

export default useService;
